/* DisclosureSort is a custom element for G-III, 
  copy of Disclosure class with some modifications */
/* (Not part of original Maker theme) */
class DisclosureSort extends HTMLElement {
  static instances = [];
  constructor() {
    super();
  }
  connectedCallback() {
    (this.viewport = this.closest(".drawer--instance, .layout--main-content")),
      DisclosureSort.instances.push(this),
      "loading" === document.readyState
        ? window.on("DOMContentLoaded", () => this.load())
        : this.load();
  }
  disconnectedCallback() {
    this.off("keydown.DisclosureSort"),
      this.toggle.off(
        "click.DisclosureSort keydown.DisclosureSort focusout.DisclosureSort"
      ),
      this.form.off("focusout.DisclosureSort"),
      this.links.off("click.DisclosureSort keydown.DisclosureSort"),
      this.input.off("change.DisclosureSort");
    var t = DisclosureSort.instances.indexOf(this);
    -1 < t && DisclosureSort.instances.splice(t, 1);
  }
  load() {
    (this.current_option = this.querySelector(".disclosure--current-option")),
      (this.form = this.querySelector(".disclosure--form")),
      (this.input = this.querySelector('[data-item="disclosure"]')),
      (this.links = this.querySelectorAll(".disclosure--option")),
      (this.toggle = this.querySelector(".disclosure--toggle")),
      (this.type = this.getAttribute("data-type")),
      (this.toggle_and_form_gap = 8),
      (this.window_and_form_gap = 16),
      this.updateFormListeners(),
      this.showFormWhenClick(),
      this.hideFormWhenFocusOut(),
      this.setOptionOnClick(),
      this.updateFormPosition(),
      /*"option-picker" !== this.type &&*/ this.optionChangeCallback();
  }
  updateFormListeners() {
    new ResizeObserver(() => this.updateFormPosition()).observe(document.body),
      this.closest('.drawer--instance[data-side="left"]') &&
        window.on("theme:drawer:left:opened.DisclosureSort", () =>
          this.updateFormPosition()
        ),
      this.closest('.drawer--instance[data-side="right"]') &&
        window.on("theme:drawer:right:opened.DisclosureSort", () =>
          this.updateFormPosition()
        );
  }
  showFormWhenClick() {
    this.toggle.on("click.DisclosureSort keydown.DisclosureSort", (t) => {
      if ("keydown" !== t.type || "Enter" === t.key) {
        t.preventDefault();
        const e = "true" === this.toggle.getAttribute("aria-expanded");
        DisclosureSort.instances.forEach((t) =>
          t === this ? this.toggleFormDisplay(!e) : t.toggleFormDisplay(!1)
        );
      }
    });
  }
  hideFormWhenFocusOut() {
    this.on("focusout.DisclosureSort", ({ relatedTarget: t }) => {
      this.form.contains(t) || this.toggleFormDisplay(!1);
    }),
      this.on("keydown.DisclosureSort", ({ key: t }) => {
        "Escape" === t && (this.toggleFormDisplay(!1), this.toggle.focus());
      });
  }
  setOptionOnClick() {
    this.links.on(
      "click.DisclosureSort keydown.DisclosureSort",
      ({ key: t, type: e, target: s }) => {
        if ("Enter" === t) this.toggle.focus();
        else if ("keydown" === e) return;
        var i = s.dataset.value,
          o = s.innerHTML;
        this.toggleFormDisplay(!1),
          (this.current_option.innerHTML = o),
          this.links.forEach((t) => t.setAttribute("aria-current", !1)),
          s.setAttribute("aria-current", !0),
          (this.input.value = i),
          this.input.trigger("change");
      }
    );
  }
  toggleFormDisplay(t) {
    this.toggle.setAttribute("aria-expanded", t),
      this.form.setAttribute("data-transition-active", t);
  }
  updateFormPosition() {
    this.toggle_pos = this.offset();
    var { height: t, width: e } = theme.utils.getHiddenDimensions(this.form);
    this.updateFormYPosition(t),
      "option-picker" !== this.type && this.updateFormXPosition(e);
  }
  updateFormYPosition(t) {
    var e = this.viewport ? this.viewport.offsetHeight : 0,
      s = t + this.toggle_and_form_gap + this.window_and_form_gap,
      i = this.toggle_pos.top,
      o = e - i - this.toggle.offsetHeight;
    this.form.style.top =
      o < s && o < i
        ? `-${t + this.toggle_and_form_gap}px`
        : this.toggle.offsetHeight + this.toggle_and_form_gap + "px";
  }
  updateFormXPosition(t) {
    var e =
        (this.viewport ? this.viewport.offsetWidth : 0) - this.toggle_pos.left,
      s = t + this.window_and_form_gap;
    this.form.style.right =
      e <= s
        ? this.toggle.offsetWidth + this.window_and_form_gap - e + "px"
        : "unset";
  }
  optionChangeCallback() {
    this.input.on("change.DisclosureSort", ({ target: t }) => {
      /*"url-redirect" === this.type
        ? (window.location.href = t.value)
        : "localization" === this.type && t.closest("form").submit();*/
      var filterForm = document.querySelector('form.filter--form');
      //window.console.log('filters',filterForm);
      var hasSort = filterForm ? filterForm.querySelector('.filter--category-sort') : false;
      //window.console.log('hasSort',hasSort);
      if (filterForm && hasSort) {
        filterForm.querySelector('[name="sort_by"][value="'+t.value+'"]').nextElementSibling.click();
      } else {
        window.console.error('sort options are missing')
      }
    });
  }
}
const disclosureSortEl = customElements.get("disclosure-sort-root");
disclosureSortEl || customElements.define("disclosure-sort-root", DisclosureSort);
